<div class="event-info">
  <div class="date">
    <div class="day">{{ event.date | date: 'dd' }}</div>
    <div class="month">{{ event.date | date: 'MMM' }}</div>
  </div>

  <a [href]="event.link" class="more">למידע נוסף</a>
</div>

<h4 class="event-title">{{ event.title }}</h4>

<div class="event-description">{{ event.description }}</div>
